import isUndefined from 'Lib/utils/isUndefined';

const focusVisibleStyle = ':focus-visible';
let isFocusVisibleSupported;

export const hasFocusVisibleStyle = (node?: Element) => {
  let hasStyle = false;

  if (!node) {
    return false;
  }
  // skip test if not supported
  if (!isUndefined(isFocusVisibleSupported) && !isFocusVisibleSupported) {
    return false;
  }

  try {
    const hasMatch = node?.matches(focusVisibleStyle);
    hasStyle = !!hasMatch;
  } catch (e) {
    return hasStyle;
  }

  return hasStyle;
};

export const getIsFocusVisibleSupported = () => {
  if (!__CLIENT__) {
    return false;
  }

  // detect only once
  if (isUndefined(isFocusVisibleSupported)) {
    isFocusVisibleSupported = false;
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
    const div = document.createElement('div');
    try {
      div?.matches(focusVisibleStyle);
      isFocusVisibleSupported = true;
    } catch (e) {
      isFocusVisibleSupported = false;
    }
  }

  return isFocusVisibleSupported;
};
